export const IconName = {
  Warning: 'Warning',
  Accept: 'Accept',
  Cancel: 'Cancel',
};

export const IconColor = {
  [IconName.Warning]: '#D83B01',
  [IconName.Accept]: '#107C10',
  [IconName.Cancel]: '#E81123',
};
